import React, { Component } from 'react';
import ProgressText from '../../components/progress-text/Progress';
import Terminal from '../../js/lib/terminal/terminal';
import Button from '../../components/button/Button';
import '../../js/lib/terminal/terminal-1.0.1.min.css';
import RFIDInstance from '../../native-interact/RFID';
import RFBluetoothInstance, { cmdLogManager } from '../../native-interact/RFBluetooth';
import switchPopup from '../../components/switch-popup/index';
import Message from '../../components/message';
import { socket } from '../../service/websocket';
import { readStore } from '../../mobx/stores/rf';
import CommandBuffer from './CommandBuffer';
import Popup from '../../components/modal/Popup';
import { cmdBufferStore } from '../../mobx/stores/command-buffer';
import cmdConfig from '../../service/command-config';
import { formatDateTime } from '../../js/utils';
import { getCmdPage } from '../../service/command';

// eslint-disable-next-line import/no-mutable-exports
export let terminalInstance = null;

export default class TerminalView extends Component {
  constructor() {
    super();
    this.state = {
      remoteDesc: '开启远程协助',
      remote: false,
      cmdPanelVisible: false,
      executing: false,
      // eslint-disable-next-line react/no-unused-state
      showLogTime: false
    };
    this.terminalRef = React.createRef();
  }

  componentDidMount() {
    this.initTerminal();
    this.addCmdLogProcess();
    window.addEventListener('unload', this.closeSocket);
  }

  componentWillUnmount() {
    this.closeSocket();
    window.removeEventListener('unload', this.closeSocket);
    cmdLogManager.delete(this.cmdLogProcess);
  }

  getCmdConfig(cmd) {
    const result = Object.values(cmdConfig).filter((item) => {
      return item.test(cmd);
    });

    return result.length > 0 ? result[0] : {};
  }

  closeSocket() {
    socket.close();
  }

  addCmdLogProcess() {
    const that = this;
    this.cmdLogProcess = function (logContent, next) {
      if (terminalInstance && 'output' in terminalInstance) {
        const now = new Date();
        const msg = logContent.replace(/\r\n/g, '<br/>');
        const logTime = that.state.showLogTime ? `[${formatDateTime(now, 'time')}.${now.getMilliseconds()}]` : '';
        const message = `${logTime}${msg}`;
        terminalInstance.output(message);
        socket.emitCommandResponse({
          state: 'load',
          data: message
        });
      }
      next();
    };
    cmdLogManager.use(this.cmdLogProcess);
  }

  changeRemote(state) {
    const desc = state ? '关闭远程协助' : '开启远程协助';
    this.setState({
      remote: state,
      remoteDesc: desc
    });
  }

  switchMode() {
    switchPopup.showSwitchPopup('expert');
  }

  toggleCmdPopup(show) {
    this.setState({ cmdPanelVisible: show });
  }

  toggleRemote() {
    const msg = this.state.remote
      ? '远程协助正在进行中，确定关闭？'
      : '开启远程协助后将关闭本地命令行输入功能，确定开启？';

    Message.confirm(msg, () => {
      if (this.state.remote) {
        socket.close();
        terminalInstance.ableCmdline();
      } else {
        socket.connect().then((socketInstance) => {
          socket.instance.on('command message', (data) => {
            if (data.type === 'cmd') {
              terminalInstance.execute(data.data);
            }
          });
          socket.on('disconnect', () => {
            // 如果服务端异常崩溃，则客户端默认会一直尝试重连websocket，需要强制关闭
            socket.close();
            terminalInstance.output('<span style="color: red;">远程调试已断开</span>');
            this.changeRemote(false);
            terminalInstance.ableCmdline();
          });
          socket.on('error', (error) => {
            console.log(error);
          });
          socketInstance.on('join', (data) => {
            let message = data.msg;
            if (data.code === 200) {
              message = '远程调试开启成功';
              terminalInstance.disableCmdline();
            }
            terminalInstance.output(`${message}<br/>`);
          });
          terminalInstance.output('正在开启远程调试...<br/>');
          // eslint-disable-next-line import/no-named-as-default-member
          socketInstance.emit('join', { type: 'client', room: readStore.RFID || 'temporary' });
        });
      }
      this.changeRemote(!this.state.remote);
    });
  }

  initTerminal() {
    const that = this;
    terminalInstance = new Terminal(
      // 命令行容器
      this.terminalRef.current,
      {
        welcome: `Welcome to HTML5 Terminal!<br/>${new Date().toLocaleString()}<br/><br/>`,
        prompt: '' // 提示符
      },
      {
        execute(cmd, args) {
          const originCmd = [cmd, ...args].join(' ');
          // TODO 将内置命令封装，可以支持promise并且远程控制支持返回
          const builtinCmd = {
            clear: () => {
              return new Promise((resolve) => {
                terminalInstance.clear();
                resolve('');
              });
            },
            'show log time': function () {
              return new Promise((resolve) => {
                that.setState({
                  showLogTime: true
                });
                resolve('');
              });
            },
            'close log time': function () {
              return new Promise((resolve) => {
                that.setState({
                  showLogTime: false
                });
                resolve('');
              });
            }
          };

          if (builtinCmd[originCmd]) {
            builtinCmd[originCmd]().then((res) => {
              socket.emitCommandResponse({
                state: 'end',
                data: res
              });
              terminalInstance.endExecute(res);
            });
          } else if (/^rfid.*/.test(originCmd)) {
            const rfidCmd = originCmd.split(' ').slice(1);

            if (rfidCmd[0] === 'read') {
              RFIDInstance.read({
                step: 'remote_read',
                desc: '远程读卡命令'
              }, rfidCmd.slice(1))
                .then((res) => {
                  socket.emitCommandResponse({
                    state: 'end',
                    data: res
                  });
                  terminalInstance.endExecute(res);
                }).catch(() => {
                  const error = '<span style="color: red;">执行超时，请重试</span>';
                  socket.emitCommandResponse({
                    state: 'end',
                    data: error
                  });
                  terminalInstance.endExecute(error);
                });
            } else if (rfidCmd[0] === 'write') {
              const cmdStr = rfidCmd.slice(1).join(' ');
              RFIDInstance.write({
                step: 'remote_write',
                desc: '远程写卡命令'
              }, getCmdPage(cmdStr), cmdStr)
                .then((res) => {
                  socket.emitCommandResponse({
                    state: 'end',
                    data: res
                  });
                  terminalInstance.endExecute(res);
                }).catch(() => {
                  const error = '<span style="color: red;">执行超时，请重试</span>';
                  socket.emitCommandResponse({
                    state: 'end',
                    data: error
                  });
                  terminalInstance.endExecute(error);
                });
            }
          } else {
            RFBluetoothInstance.sendCommand(originCmd, {})
              .then(() => {
                socket.emitCommandResponse({
                  state: 'end',
                  data: ''
                });
                terminalInstance.endExecute('');
              })
              .catch(() => {
                const error = '<span style="color: red;">执行超时，请重试</span>';
                socket.emitCommandResponse({
                  state: 'end',
                  data: error
                });
                terminalInstance.endExecute(error);
              });
          }

          return 'pending';
        }
      }
    );
  }

  /**
   * @description 执行缓冲区命令
   * @param {string} cmd
   * @param {boolean} pack 是否打包一次性下发命令
   * @returns
   * @memberof TerminalView
   */
  executeCmd(cmd, pack) {
    if (this.state.executing) {
      Message.alert('有命令正在执行中，请等待执行结束');
      return;
    }

    this.setState({
      executing: true
    });

    const that = this;
    RFBluetoothInstance.cancel();

    const cmds = cmd.split(/\r\n|\n/);

    if (pack) {
      terminalInstance.execute(cmd.replace(/\r\n|\n/g, '<br />'), []);
      RFBluetoothInstance.sendBatchCommand(
        cmd,
        {
          loadFn: (data) => {
            terminalInstance.output(data.map(item => item.replace(/\r\n|\n/g, '<br />')).join(' '));
          }
        }
      ).then(() => {
        this.setState({
          executing: false
        });
        terminalInstance.endExecute('');
      }).catch(() => {
        this.setState({
          executing: false
        });
        terminalInstance.endExecute('<span style="color: red;">执行超时，请重试</span>');
      });

      return;
    }

    const tasks = cmds.map((item) => {
      return function () {
        terminalInstance.execute(item, []);
        return RFBluetoothInstance.sendCommand(
          item,
          that.getCmdConfig(item)
        );
      };
    });

    tasks.reduce(
      (previousPromise, nextPromise, index) => {
        return previousPromise
          .then(() => {
            if (index > 0) {
              terminalInstance.endExecute('');
            }
            return nextPromise();
          });
      },
      Promise.resolve()
    ).then(() => {
      terminalInstance.endExecute('');
    }).catch((error) => {
      const errorMsg = `<span style="color: red;">${error.message}</span>`;
      terminalInstance.endExecute(errorMsg);
    }).then(() => {
      this.setState({
        executing: false
      });
    });
  }

  render() {
    const { showSwitch = true } = this.props;
    return (
      <div className="terminal-view">
        {
          showSwitch ? (
            <ProgressText text="请输入相关命令进行调试" hasPre>
              <Button type="ghost" className="switch-btn" onClick={() => this.switchMode()}>切换模式</Button>
            </ProgressText>
          ) : ''
        }
        <div className="terminal-container" style={this.props.style}>
          <div ref={this.terminalRef}></div>
        </div>
        <Button
          type={this.state.remote ? 'danger' : 'primary'}
          className="remote-btn"
          onClick={() => this.toggleRemote()}
          style={{ position: 'absolute', right: showSwitch ? 10 : 0, top: showSwitch ? 50 : 0 }}
        >
          {this.state.remoteDesc}
        </Button>
        <Button
          type="primary"
          className="cmd-buffer-btn"
          onClick={() => { this.toggleCmdPopup(true); }}
          style={{ position: 'fixed', zIndex: 1000, right: 10, bottom: 100 }}
        >
          命令缓冲区
        </Button>
        <Popup
          visible={this.state.cmdPanelVisible}
          bodyStyle={{ padding: 0 }}
          onClose={() => {
            this.toggleCmdPopup(false);
          }}
        >
          {
            this.state.cmdPanelVisible ? (
              <CommandBuffer
                closePopup={() => this.toggleCmdPopup(false)}
                cmdBufferStore={cmdBufferStore}
                startExecute={(cmd, pack) => this.executeCmd(cmd, pack)}
              />
            ) : ''
          }
        </Popup>
      </div>
    );
  }
}
